import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlert, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import {SET_MODAL} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import { useEffect } from "react";
import Events from "@/utils/Events";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
  z-index:999999;
`
const ContentArea = styled.div`
  position: relative;
  width: 252px;
`
const IconDiv = styled.div`
  background: ${themes.red};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
`
const CallAction = styled.p`
  color: ${themes.estadao};
  font-weight: 700;
  line-height: 1.2;
`
const Text = styled.p`
  font-size: 12px;
  b{
    &.central{
      margin: 5px 0 5px 0;
    }
    a{
      font-weight: 700;
    }
    font-weight: 700;
  }
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${themes.grey};
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`
export default function PedidoDuplicado() {
  const offer_type = useSelector(GET_OFFER_TYPE)

  useEffect(()=>{
    events.trigger("pagamento_cartao_pedido_processando", { offer_type })
  });

    const dispatch = useDispatch();
    const events = new Events();

    return (
        <Block>
            <CloseButton onClick={() => {
                dispatch(SET_MODAL({type: null, show: false})), events.trigger("pagamento_cartao_fechar_pedido_processando", { offer_type })
            }}><Icon path={mdiClose} size={1}></Icon></CloseButton>

            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlert} size={1}/>
                </IconDiv>
                <CallAction>
                    Estamos processando seu pedido
                </CallAction>
                <Text>
                    Aguarde enquanto processamos seu pedido, pode demorar até 48 horas para finalizar o processamento. <br/><br/>
                    Em caso de dúvidas entre em contato com a central de atendimento: <br/>
                    <b>4003-5323</b> <small>(capitais e regiões metropolitanas)</small> <br/>
                    <b>0800 014 7720</b> <small>(demais localidades; exceto ligações via celular)</small> <br/> <br/>
                    <b className={'central'}>Enquanto isso aproveite o conteudo do <a href={'https://estadao.com.br'} target={'_blank'}>Estadão</a></b> <br/>
                </Text>
            </ContentArea>
        </Block>
    )
}